function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScImage = function SvgScImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "m3 17.4 2.533-2.786a1 1 0 0 1 1.48 0l1.793 1.972a1 1 0 0 0 1.48 0l4.247-4.672a1 1 0 0 1 1.48 0L21 17.4m-10.8-9a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0ZM4 21h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1Z",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScImage;